"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
import Modal from "react-modal";
const Card = (props: any) => {
  const {
    id,
    title,
    subtitle1,
    subtitle2,
    description,
    image,
    link,
    slugUrl,
    isVideo,
    isLoan,
    instName,
    instCity,
    instCountry,
    exhibitionName,
    exhibitionDateFrom,
    exhibitionDateTo,
    externalLink,
    cls,
    fullCardCls,
    subtitle1Cls,
    titleCls,
  } = props;

  const [isVideoHovered, setIsVideoHovered] = useState(true);
  const [isLinkHovered, setIsLinkHovered] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [youtubeValue, setyoutubeValue] = useState(link?.split("=")[1]);
  const customStyles = {
    content: {
      width: "50%",
      margin: "auto",
      backgroundColor: "black",
    },
  };

  const [isFullScreen, setIsFullScreen] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const handleImageClick = () => {
    setShowPopup(true);
  };
  const isValidImage = (src: string) => {
    const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
    const lowercaseSrc = src?.toLowerCase();
    return validExtensions.some(
      (extension) => lowercaseSrc?.endsWith(extension),
    );
  };
  const closePopup = () => {
    setShowPopup(false);
  };

  const toggleFullScreen = () => {
    if (!isFullScreen) {
      enterFullScreen();
    } else {
      exitFullScreen();
    }
  };

  const enterFullScreen = () => {
    const videoElement = iframeRef.current;

    if (videoElement) {
      const requestFullScreen =
        videoElement.requestFullscreen ||
        (videoElement as any).mozRequestFullScreen ||
        (videoElement as any).webkitRequestFullscreen ||
        (videoElement as any).msRequestFullscreen;

      if (requestFullScreen) {
        requestFullScreen.call(videoElement);
        setIsFullScreen(true);
      }
    }
  };

  const exitFullScreen = () => {
    document.exitFullscreen();
    setIsFullScreen(false);
  };

  useEffect(() => {
    setyoutubeValue(link?.split("=")[1]);

  }, [link]);
  return (
    <>
      <div>
        <div
          className={`max-w-sm overflow-hidden group hover:border-b-4 border-black border-b-2 relative card-h ${fullCardCls}`}
        >
          {isVideo ? (
            <div
              className="relative overflow-hidden"
              onClick={handleImageClick}
              onMouseEnter={() => setIsVideoHovered(false)}
              onMouseLeave={() => setIsVideoHovered(true)}
            >
              {youtubeValue?.length > 0 ? (
                <Image
                  width={480}
                  height={360}
                  alt="test"
                  className="w-full card-image hover:scale-110 transition duration-500 cursor-pointer"
                  src={image}
                ></Image>
              ) : null}

              {isVideoHovered ? (
                <Image
                  src="/assets/icons/video-green.svg"
                  alt="Green"
                  width={30}
                  height={30}
                  className="cursor-pointer absolute left-[85%] -mt-[15%]"
                />
              ) : (
                <Image
                  src="/assets/icons/video-black.svg"
                  alt="Green"
                  width={30}
                  height={30}
                  className="cursor-pointer absolute left-[85%] -mt-[15%]"
                />
              )}
            </div>
          ) : (
            <Link href={`/${slugUrl}/[slug]${isLoan ? `?isFromLoans=true` : ''}`} as={`/${slugUrl}/${id}${isLoan ? `?isFromLoans=true` : ''}`}>
              <div className="relative overflow-hidden">
                {isValidImage(image) && (
                  <Image
                    width={180}
                    height={37}
                    alt="Card Image"
                    className={`w-full card-image hover:scale-110 transition duration-500 cursor-pointer ${cls}`}
                    src={image}
                  ></Image>
                )}
                {!isValidImage(image) && (
                  <Image
                    width={180}
                    height={37}
                    alt="Card Image"
                    className={`w-full card-image hover:scale-110 transition duration-500 cursor-pointer ${cls}`}
                    src="/assets/images/noimage.jpg"
                  ></Image>
                )}
              </div>
            </Link>
          )}

          <div
            className={`py-3 ${isVideo ? "lg:h-[160px] md:h-[150px] h-[130px]" : ""
              } `}
          >
            {isVideo ? (
              <p
                className="card-title pb-[5px]"
                onClick={() => setShowPopup(true)}
              >
                {title}
              </p>
            ) : (
              <Link href={`/${slugUrl}/[slug]${isLoan ? `?isFromLoans=true` : ''}`} as={`/${slugUrl}/${id}${isLoan ? `?isFromLoans=true` : ''}`}>
                <p className={`card-title ${titleCls}`}>{title}</p>
              </Link>
            )}

            <p className={`bdy-txt-2 ${subtitle1Cls}`}>{subtitle1}</p>

            {isLoan ? <p className="bdy-txt-2">{subtitle2}</p> : null}
            {isLoan ? null : (
              <ReactMarkdown
                remarkPlugins={[remarkBreaks]}
                rehypePlugins={[rehypeRaw]}
                className={`bdy-txt-3 ${isVideo ? "absolute bottom-0 mb-[5px]" : ""
                  }`}
              >
                {description?.replace(/\n/gi, "&nbsp; \n")}
              </ReactMarkdown>
            )}

            {isLoan && (
              <div className="flex justify-between -mt-[20px]">
                <div className="bdy-txt-3 pt-[20px] -mb-[5px] w-[60%] lg:w-full">
                  <div className="flex whitespace-nowrap">
                    <p>{instName}</p>
                    {instCity && <span className="pr-1">,</span>}
                    <p>{instCity}</p>

                    {instCountry && <span className="pr-1">,</span>}

                    <p>{instCountry}</p>
                  </div>
                  <p>{exhibitionName}</p>
                  <div className="flex whitespace-nowrap">
                    <p>
                      {exhibitionDateFrom?.replace(/-/g, ".").split("T")[0]}
                    </p>{" "}
                    <span className="ml-2 mr-2">-</span>
                    <p>{exhibitionDateTo?.replace(/-/g, ".").split("T")[0]}</p>
                  </div>
                </div>
                <div
                  className="absolute bottom-0 right-0 mb-[10px]"
                  onMouseEnter={() => setIsLinkHovered(false)}
                  onMouseLeave={() => setIsLinkHovered(true)}
                >
                  <Link href={externalLink || ""} target="_blank">
                    {isLinkHovered ? (
                      <Image
                        src="/assets/icons/external-link-green.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    ) : (
                      <Image
                        src="/assets/icons/external-link-black.svg"
                        alt="Green"
                        width={30}
                        height={30}
                        className="cursor-pointer"
                      />
                    )}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        {showPopup && isVideo && (
          <div onClick={closePopup}>
            <Modal style={customStyles} isOpen={true}>
              <div
                className="popup-content xl:h-[100%] md:p-[30px] h-[400px] mt-[25%] w-auto md:h-auto md:ml-0 md:mt-0"
                onClick={closePopup}
              >
                <div className="flex top-0 right-0 absolute bg-[#2A2A2A]">
                  <button
                    className="right-0 hover:bg-[#0C0C0C] p-[7px]"
                    onClick={toggleFullScreen}
                  >
                    <Image
                      src="/assets/icons/full-screen.svg"
                      alt="Full"
                      width={30}
                      height={30}
                      className="w-[30px] h-[30px]"
                    />
                  </button>
                  <button
                    className="right-0 p-[15px] hover:bg-[#0C0C0C]"
                    onClick={closePopup}
                  >
                    <Image
                      src="/assets/icons/close-white.svg"
                      alt="Close"
                      width={15}
                      height={15}
                      className="w-[15px] h-[15px]"
                    />
                  </button>
                </div>
                <iframe
                  className="mt-[25px]"
                  ref={iframeRef}
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${youtubeValue}`}
                  title="YouTube Video"
                  frameBorder="0"
                  allowFullScreen
                />

              </div>
            </Modal>
          </div>
        )}
      </div>
    </>
  );
};
export default Card;
